// src/layouts/corui/CoreUIStyles.jsx
import './scss/style.scss'

// We use those styles to show code examples, you should remove them in your application.
import './scss/examples.scss'

const CoreUIStyles = () => null
export default CoreUIStyles
